/** @file holdFrame: a frame quantised to `hold`-frame steps counted from its key. */

/** `keyFrame + floor((frame - keyFrame) / hold) * hold`; `hold <= 1` leaves the frame unchanged. */
export function holdFrame(frame: number, keyFrame: number, hold: number): number {
  return hold <= 1 ? frame : keyFrame + Math.floor((frame - keyFrame) / hold) * hold;
}
